import { render, staticRenderFns } from "./GetCardList.vue?vue&type=template&id=13e8f3be&scoped=true&"
import script from "./GetCardList.vue?vue&type=script&lang=js&"
export * from "./GetCardList.vue?vue&type=script&lang=js&"
import style0 from "./GetCardList.vue?vue&type=style&index=0&id=13e8f3be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e8f3be",
  null
  
)

export default component.exports